var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`menu-item ${_vm.isActive ? 'active' : ''}`,on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_c('typo',{attrs:{"name":"menu-16-normal"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }